<template>
    123
    <div class="left-side" v-show="catalogue.length > 0">
        <div class="side-wrapper" v-for="pItem in catalogue" :key="pItem.pId">
            <div class="side-title">{{ pItem.pName }}</div>
            <div class="side-menu">
                <router-link v-for="item in pItem.name" :key="item.id" active-class="active" :to="item.to">
                    <img :src="item.imageUrl" />
                    {{ item.name }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 显示
                envshow: process.env.VUE_APP_SHOW,
                // 菜单
                catalogue: [
                    {
                        pId: 5,
                        pName: "手机详情页",
                        name: [
                            { id: 1, imageUrl: "", name: "模板", to: "/phones/details" },
                            { id: 3, imageUrl: "", name: "分页数据", to: "/getdata/paging" },
                            { id: 4, imageUrl: "", name: "发送数据", to: "/getdata/send" },
                            { id: 5, imageUrl: "", name: "菜单栏", to: "/getdata/searchmenu" },
                            { id: 6, imageUrl: "", name: "跨域测试", to: "/phones/usercard" },
                        ],
                    },
                    {
                        pId: 1,
                        pName: "炫酷卡片",
                        name: [
                            {
                                id: 1,
                                imageUrl: "",
                                name: "用户卡片",
                                to: "/card/userCard",
                            },
                            {
                                id: 2,
                                imageUrl: "",
                                name: "肖像卡片",
                                to: "/card/profileCard",
                            },
                            {
                                id: 3,
                                imageUrl: "",
                                name: "新闻卡片",
                                to: "/card/newsCard",
                            },
                        ],
                    },
                    {
                        pId: 2,
                        pName: "优美画面",
                        name: [
                            { id: 1, imageUrl: "", name: "猫吻蝴蝶", to: "/beautiful/catButterfly" },
                            { id: 2, imageUrl: "", name: "绿眼猫咪", to: "/beautiful/greenEyesCat" },
                        ],
                    },
                    {
                        pId: 3,
                        pName: "小玩意儿",
                        name: [
                            { id: 1, imageUrl: "", name: "流光按钮", to: "/gadget/timeButton" },
                            { id: 2, imageUrl: "", name: "动画按钮", to: "/gadget/animationButton" },
                            { id: 3, imageUrl: "", name: "文章详情页", to: "/gadget/articleDetails" },
                            { id: 4, imageUrl: "", name: "个人信息页", to: "/gadget/personInfo" },
                            { id: 5, imageUrl: "", name: "按钮悬停样式", to: "/gadget/hoverButton" },
                        ],
                    },
                    {
                        pId: 4,
                        pName: "小游戏",
                        name: [
                            { id: 1, imageUrl: "", name: "井字棋", to: "/games/tictactoe" },
                            { id: 2, imageUrl: "", name: "百宝箱", to: "/procurement" },
                            { id: 2, imageUrl: "", name: "记录线", to: "/record" },
                            { id: 2, imageUrl: "", name: "喜捷径", to: "/shortcut" },
                        ],
                    },
                ],
            };
        },
    };
</script>

<style lang="scss" scoped>
    .left-side {
        display: none;
        flex-basis: 240px;
        border-right: 1px solid rgba(113 119 144 / 25%);
        padding: 26px;
        overflow: auto;
        flex-shrink: 0;

        @media screen and (max-width: 945px) {
            display: none;
        }
    }

    .side-wrapper + .side-wrapper {
        margin-top: 20px;
    }

    .side-title {
        color: rgb(218, 133, 133);
        margin-bottom: 14px;
    }

    .side-menu {
        display: flex;
        flex-direction: column;
        white-space: nowrap;

        a {
            text-decoration: none;
            color: #fff;
            display: flex;
            align-items: center;
            font-weight: 400;
            padding: 10px;
            font-size: 14px;
            border-radius: 6px;
            transition: 0.3s;

            &:hover {
                background-color: rgba(12 15 25 / 30%);
            }

            &.active {
                color: #db6ff3;
            }
        }

        img {
            width: 16px;
            margin-right: 8px;
        }
    }

    .updates {
        position: relative;
        top: 0;
        right: 0;
        margin-left: auto;
        width: 18px;
        height: 18px;
        font-size: 11px;
    }
</style>
